import React from 'react';
import { Icon } from './Icon.js';
export const IconShirt = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 7V21", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7 2L12 6.5L17 2", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M17.0307 4H21V21H3V4H6.97669", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M16 15H17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M17 2V10H16.5L12 7L7.5 10H7V2H17Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));
};
//# sourceMappingURL=IconShirt.js.map